import { StyledTokenInputWrapper } from '@/pages/escript/landing/SubmitSectionStyles';
import { tokenPlaceholder } from '@montugroup/circuit-shared/constants/escript';
import { Link, TextField } from '@montugroup/design-system';
import { styled } from '@mui/material/styles';
import type { FieldErrors } from 'react-hook-form';
import { TokenDialog } from './TokenDialog';
import type { TokenInputFieldProps } from './types';

type StyledLinkProps = {
  formErrors: FieldErrors;
};

const StyledLink = styled(Link, { shouldForwardProp: (prop) => prop !== 'formErrors' })<StyledLinkProps>(
  ({ formErrors, theme }) => ({
    textDecoration: 'underline',
    marginLeft: theme.spacing(4),
    marginTop: formErrors.tokenInput ? 5 : 0,
  }),
);

export function TokenInputField({
  field,
  fieldState,
  formErrors,
  openTokenDialog,
  setOpenTokenDialog,
}: TokenInputFieldProps) {
  const { onChange, value, ref } = field;
  const { error } = fieldState;

  return (
    <>
      <StyledTokenInputWrapper spacing={2}>
        <TextField
          type="text"
          variant="outlined"
          value={value}
          inputRef={ref}
          onChange={(event) => {
            const removeWhitespaceValue = event.target.value.replace(/\s/g, '');
            onChange(removeWhitespaceValue);
          }}
          label={tokenPlaceholder}
          error={Boolean(error)}
          helperText={error ? <span data-dd-privacy="allow">{error.message}</span> : ''}
          fullWidth
          sx={{ width: '100%' }}
        />

        <StyledLink
          data-tracking-id="escript_onboarding_find_token"
          type="button"
          variant="caption"
          color="textSecondary"
          formErrors={formErrors}
          component="button"
          onClick={(event) => {
            event.preventDefault();
            setOpenTokenDialog(true);
          }}
        >
          Where do I find my token?
        </StyledLink>
      </StyledTokenInputWrapper>
      <TokenDialog onClose={() => setOpenTokenDialog(false)} open={openTokenDialog} />
    </>
  );
}
